module.exports = __webpack_public_path__ + "img/9news.fbf7de78.png";